export default function setInputError(element,focus){
    let tagName = $(element).prop('tagName');

    console.log(element);
    if(tagName){
      const elementType = tagName.toLowerCase();

      $(element).addClass("u2diInputError");

      if(elementType==="input" || elementType==="textarea"){
        $(element).on('input', function() {
          $(element).removeClass("u2diInputError");
        });
      }else if(elementType==="div"){
        $(element).on('mouseup', function() {
          $(element).removeClass("u2diInputError");
        });
      }

      if(focus===true){
        $(".ModalManager").animate({scrollTop: $(element).offset().top+50}, 500);
      }
    }
}
